var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom has-text-right"},[_vm._t("form-actions")],2)}
var staticRenderFns = []

export { render, staticRenderFns }